module.exports = __webpack_public_path__ + "img/log-in.2a7cf5e5.svg";